
import PhoneNumber from '@/lib/common/objects/PhoneNumber';
import VersionNumber from '@/lib/util/VersionNumber';
import { get, post } from '@/lib/util/RestClient';
import { kioskSetup } from '@/lib/KioskSetup';


class KioskRestApi {

  private static singleton: KioskRestApi | null = null;

  public static instance(): KioskRestApi {
    if ( null === KioskRestApi.singleton ) {
      KioskRestApi.singleton = new KioskRestApi();
    }
    return KioskRestApi.singleton;
  }

  private constructor() {}

  public async getServerVersionNumber(): Promise<VersionNumber> {
      try {
        const response = await get<{ version: string }>('/rs/v1/version');
        if ( 'payload' in response ) {
          return new VersionNumber(response.payload.version);
        }
        else {
          throw Error(`${response.responseCode}: ${response.message}`);
        }
      }
      catch (error) {
        throw Error(error);
      }
  }

  public async sendTextToCustomer(toPhoneNumber: PhoneNumber, productName: string): Promise<string> {
    try {
      const response = await post<string>('/rs/v1/text-product-to-customer', {
        kioskId: kioskSetup.kioskId.toString(),
        toPhoneNumber: toPhoneNumber.getE164Number(),
        productName,
      });
      if ( 'payload' in response ) {
        return response.payload;
      }
      else {
        // Failure
        console.log(`  ${response.responseCode}: ${response.message}`);
        throw Error(`${response.responseCode}: ${response.message}`);
      }
    }
    catch (error) {
      throw Error(error);
    }
  }

}

export const api = KioskRestApi.instance();
